/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_BeginInputs */



/**
* | output |
* | --- |
* | "Begin practice conversation" |
*
* @param {Practice_Session_BeginInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_begin = /** @type {((inputs?: Practice_Session_BeginInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_BeginInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Begin oefengesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencer l'entretien")
	return /** @type {LocalizedString} */ ("Begin practice conversation")
});